import {
  useWizardWithQueryParam,
  WizardOptions,
} from "../useWizard/useWizardWithQueryParam";
import type { UseWizardWithOperationsProps, WizardOperation } from "./types";
import { useWizardOperationController } from "./useWizardOperationController";

type UseWizardWithQueryParamAndOperationsProps<
  TStep extends PropertyKey,
  TOperation extends WizardOperation,
> = UseWizardWithOperationsProps<TStep, TOperation> & {
  options?: WizardOptions;
};

export const useWizardWithQueryParamAndOperations = <
  TStep extends PropertyKey,
  TOperation extends WizardOperation,
>({
  steps,
  options,
  executeOperation,
  onComplete,
  onError,
}: UseWizardWithQueryParamAndOperationsProps<TStep, TOperation>) => {
  const { operations, completeWizardWithOperations } =
    useWizardOperationController({
      executeOperation,
      onComplete,
      onError,
    });

  const wizard = useWizardWithQueryParam({
    steps,
    options,
    onComplete: completeWizardWithOperations,
  });

  return { operations, wizard };
};
